var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('h3',[_vm._v("予期せぬエラーが発生しました")]),_c('div',[_vm._v(" エラーメッセージ："+_vm._s(_vm.errorMessage)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }